import React, { createContext, useContext, useState } from "react";

const STORAGE_KEY = "portfolio-muted";

const SoundContext = createContext({ isMuted: false, toggleMute: () => {} });

export const SoundProvider = ({ children }) => {
  const [isMuted, setIsMuted] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  const toggleMute = () =>
    setIsMuted((prev) => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEY, String(next)); } catch {}
      return next;
    });

  return (
    <SoundContext.Provider value={{ isMuted, toggleMute }}>
      {children}
    </SoundContext.Provider>
  );
};

export const useSoundContext = () => useContext(SoundContext);
